const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Convert a stored object-storage path into a public URL served by the backend.
export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  // Sudah berupa URL path (mis. data banner yang disisipkan di HTML awal beranda).
  if (path.startsWith("/")) return path;
  return `${BACKEND_URL}/api/files/${path}`;
}

export function apiUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

// Product cover thumbnail (falls back to main url, then empty).
export function coverThumb(product) {
  const f = product?.foto?.[0];
  if (!f) return "";
  return mediaUrl(f.thumb || f.url);
}

// Logo statis bawaan: dipakai sejak render pertama supaya nama toko tidak pernah
// muncul sebagai teks pengganti logo.
export const LOGO_GELAP = "/logo-hoonstore.png";
export const LOGO_TERANG = "/logo-hoonstore-putih.png";
export const logoUrl = (path) => (path ? mediaUrl(path) : LOGO_GELAP);
export const logoTerangUrl = (path) => (path ? mediaUrl(path) : LOGO_TERANG);
